import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Loading from "../common/Loading";
import { postActionDataDB } from "../../utils/apiUtils";
import { postProfileData } from "../../utils/profileUtils";
import { useQueryClient } from '@tanstack/react-query';
import { clearCache } from "../../utils/reactQueryHooks";

export default function Logout() {
    const { logout } = useAuth0();
    const queryClient = useQueryClient();

    useEffect(() => {
        async function handleLogout() {
            try {
                // First, properly save cards using our updated clearCache function
                // which will ensure cards are saved to server before clearing the cache
                await clearCache(queryClient);
                
                // Handle other data submissions that aren't covered by React Query
                await Promise.all([postActionDataDB(), postProfileData()]);
            } catch (error) {
                console.error("Error during logout data submission:", error);
            } finally {
                // Set hasCardsLoaded to false in localStorage
                localStorage.setItem("hasCardsLoaded", JSON.stringify({
                    status: false, 
                    timestamp: new Date().toISOString()
                }));
                
                // Finally logout
                logout({returnTo: window.location.origin});
            }
        }

        handleLogout();
    }, [logout, queryClient]);
    
    return (
        <Loading />
    );
}